import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import MemberAchievementsPage from "@/pages/member/MemberAchievementsPage";

export const Route = createFileRoute("/member/achievements")({
  head: () => pageHead("Member · Achievements", "AKIVA member · achievements portal.", "/member/achievements", true),
  component: MemberAchievementsPage,
});
